import getValueFromPath from '@/core/components/offer/helpers/get-value-from-path';

const OfferAdditionalItem = ({ props }) => {
    const { offer, settings } = props;

    const { label, value, valueFormatter, visibility, className } = settings;

    let itemValue = getValueFromPath(offer, value);

    const isVisible = visibility ? visibility(itemValue) : true;

    if (!isVisible) {
        return;
    }

    if (valueFormatter) {
        itemValue = valueFormatter(itemValue);
    }

    return (
        <div class={['l-ss-c-offer-content-item', className]}>
            <span>{label}</span>
            <span>{itemValue}</span>
        </div>
    );
};

OfferAdditionalItem.props = {
    offer: {
        type: Object,
    },
    settings: {
        type: Object,
    },
};

export default OfferAdditionalItem;
